import React from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { Tabs, Tab, Box } from "@material-ui/core";

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      style={{ minHeight: window.innerHeight - 114, flex: 1 }}
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box style={{ padding: 32 }} p={3}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: "flex",
  },
  tabs: {
    width: 200,
    borderRight: `1px solid ${theme.palette.divider}`,
  },
  tabsRoot: {
    padding: "16px 32px",
  },
}));

export default function ScrollTab({ content }: any) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        className={classes.tabs}
      >
        {content.map((r: any, i: number) => (
          <Tab
            key={i}
            classes={{
              root: classes.tabsRoot,
            }}
            label={r.tab}
            {...a11yProps(i)}
          />
        ))}
      </Tabs>
      {content.map((r: any, i: number) => (
        <TabPanel key={i} value={value} index={i}>
          {r.tabPanel}
        </TabPanel>
      ))}
    </div>
  );
}
